(() => {
  const setupDetailsIcons = () => {
    document.querySelectorAll('[data-bb-exclusive-details]').forEach((group) => {
      group.querySelectorAll('details').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          group.querySelectorAll('details[open]').forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDetailsIcons, { once: true });
  } else {
    setupDetailsIcons();
  }
})();
